export default __webpack_public_path__ + "static/media/Finished.aa99b690.jpg";